import { Badge } from "@/components/ui/badge";
import { sumsubHub } from "@/lib/api";
import { useBlobUrl } from "@/lib/protectedFile";

export const ANSWER_TONE = {
  GREEN: "bg-emerald-100 text-emerald-800 border-emerald-300",
  RED: "bg-red-100 text-red-900 border-red-300",
  YELLOW: "bg-amber-100 text-amber-900 border-amber-300",
  none: "bg-slate-100 text-slate-600 border-slate-300",
};
export const STATUS_TONE = {
  completed: "bg-slate-100 text-slate-700 border-slate-300",
  init: "bg-sky-50 text-sky-800 border-sky-300",
  pending: "bg-violet-50 text-violet-800 border-violet-300",
  queued: "bg-violet-50 text-violet-800 border-violet-300",
  prechecked: "bg-violet-50 text-violet-800 border-violet-300",
  onHold: "bg-amber-50 text-amber-900 border-amber-300",
};
export const STATUS_LABEL = { completed: "Completed", init: "Started", pending: "Pending review", queued: "Queued", prechecked: "Pre-checked", onHold: "On hold" };

export const AnswerPill = ({ answer, testId, className = "" }) => (
  <Badge variant="outline" className={`text-[10px] font-bold tracking-wide px-1.5 h-4 ${ANSWER_TONE[answer] || ANSWER_TONE.none} ${className}`} data-testid={testId}>
    {answer || "—"}
  </Badge>
);
export const StatusPill = ({ status, testId }) => (
  <Badge variant="outline" className={`text-[10px] font-medium px-1.5 h-4 whitespace-nowrap ${STATUS_TONE[status] || STATUS_TONE.completed}`} data-testid={testId}>
    {STATUS_LABEL[status] || status || "—"}
  </Badge>
);
export const LabelPill = ({ children, tone = "slate" }) => (
  <Badge variant="outline" className={`text-[9px] font-mono px-1 h-4 ${tone === "red" ? "bg-rose-50 text-rose-700 border-rose-200" : tone === "amber" ? "bg-amber-50 text-amber-800 border-amber-200" : "bg-slate-50 text-slate-600 border-slate-200"}`}>
    {children}
  </Badge>
);

export const fmtTs = (s) => {
  if (!s) return "—";
  const d = new Date(String(s).replace(" ", "T").replace(/\+0000$/, "Z"));
  return Number.isNaN(d.getTime()) ? s : d.toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};
export const fmtDate = (s) => (s ? String(s).slice(0, 10).split("-").reverse().join("/") : "—");
export const nice = (s) => (s || "").replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());

// Images need the bearer token, so they come through axios as blobs.
export function AuthImg({ applicantId, imageId, inspectionId, preview = true, alt = "", className = "", testId, onClick }) {
  // The applicant uploaded the file, so only a blob the classifier calls an image reaches an <img>.
  const file = useBlobUrl(
    applicantId && imageId ? `${applicantId}:${imageId}:${inspectionId || ""}:${preview}` : null,
    () => sumsubHub.imageBlob(applicantId, imageId, { inspectionId, preview })
  );
  const err = file.status === "error" || (file.status === "ready" && file.kind !== "image");
  const src = file.status === "ready" && file.kind === "image" ? file.url : null;
  if (err) return <div className={`flex items-center justify-center bg-slate-100 text-[10px] text-slate-400 ${className}`} data-testid={testId}>no preview</div>;
  if (!src) return <div className={`animate-pulse bg-slate-100 ${className}`} data-testid={testId} />;
  if (!onClick) return <img src={src} alt={alt} className={className} data-testid={testId} />;
  return (
    <button type="button" className="p-0 border-0 bg-transparent" onClick={onClick}>
      <img src={src} alt={alt} className={className} data-testid={testId} />
    </button>
  );
}
